/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumSwitch.vue?vue&type=template&id=f247a076&scoped=true&"
import script from "./ForumSwitch.vue?vue&type=script&setup=true&lang=js&"
export * from "./ForumSwitch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ForumSwitch.vue?vue&type=style&index=0&id=f247a076&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f247a076",
  null
  
)

export default component.exports